export const de = {
  ADD_COLOR_STRING_KEY: 'Farbe hinzufügen',
  ADD_TEXT_KEY: 'Text hinzufügen',
  ADD_TO_ORDER_KEY: 'Zur Bestellung hinzufügen',
  ADD_TO_CART: 'Zu Einkaufswagen hinzufügen',
  ADD_TEMPLATE: 'Vorlage hinzufügen',
  ADJUST_SIZE_KEY: 'Größe anpassen',
  ADJUST_TRANSPARENCY_KEY: 'Passen Sie die Transparenz an',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    'Durch Klicken auf Fertig erklären Sie sich mit den Nutzungsbedingungen und der Datenschutzerklärung von HP einverstanden.',
  ALIGN_BOTTOM_KEY: 'Unten ausrichten',
  ALIGN_CENTER_KEY: 'im Zentrum anordnen',
  ALIGN_KEY: 'ausrichten',
  ALIGN_LEFT_KEY: 'Anfang',
  ALIGN_MIDDLE_KEY: 'mittig ausrichten',
  ALIGN_RIGHT_KEY: 'Ende',
  ALIGN_TOP_KEY: 'Top ausrichten',
  ALL_TAB_TITLE_KEY: 'Alle',
  ALMOST_DONE_TITLE_KEY: 'Fast fertig!',
  AND_KEY: 'und',
  APPLY_KEY: 'Anwenden',
  AREA_CODE: 'Vorwahl',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Inhalt durchsuchen und die Bilder für Ihren Entwurf auswählen oder eigene Bilder hochladen',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Design in Vorschau anzeigen oder Details optimieren',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Design anpassen und andere Elemente zu Ihrem Projekt hinzufügen',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'Wenn das Design fertig ist, klicken Sie auf WEITER, um eine abschließende Prüfung durchzuführen und den Auftrag zu erteilen.',
  BACK_KEY: 'Zurück',
  BACKGROUND_KEY: 'Hintergrund',
  BACKGROUND_UPPER_CASE_KEY: 'HINTERGRUND',
  BACKGROUND_CONTRAST_KEY: 'Hintergrundkontrast',
  BLANK_INSPIRATION_CATEGORY_KEY:
    'Keine Inspirationen in dieser Kategorie gefunden',
  BRING_TO_FRONT_KEY: 'In den Vordergrund',
  CANCEL_TEXT_KEY: ' Abbrechen ',
  CENTIMETERS_KEY: 'Zentimeter',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Ändern Sie Ihre Projekteinstellungen',
  CHECKBOX_CONTENT1: 'Ich möchte den Pattern Design © Newsletter erhalten',
  CHECKBOX_CONTENT2:
    'Ich ermächtige HP, in meinem Namen ein Konto bei Pattern Design © Services zu erstellen',
  CHOOSE_FROM_COMPUTER_KEY: 'Vom Computer auswählen',
  CHOOSE_RIP_OPTIONS:
    'Eines dieser kompatiblen RIPs eines Drittanbieters auswählen',
  CHOOSE_FILE_KEY: 'Datei auswählen',
  CITY: 'Stadt',
  CLEAR_ALL_KEY: 'Alles löschen',
  CLEAR_COLOR_KEY: 'Farbe entfernen',
  CLOSE_WINDOW_KEY: 'Fenster schließen',
  CLEAR_ALL_OBJECTS: 'Alle Objekte löschen',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Dadurch werden alle Objekte aus dem Hintergrund entfernt.',
  CLEAR_DESIGN_KEY: 'Entwurf entfernen',
  COLOR_KEY: 'Farbe',
  CONTINUE_KEY: 'Fortfahren...',
  COMPANY: 'Unternehmen',
  CONGRATULATIONS_KEY: 'Herzlichen Glückwunsch!',
  CONFIRM_PASSWORD: 'Passwort bestätigen',
  CONFIRM_PATTERN_ACCOUNT_KEY:
    'Verfügen Sie noch nicht über ein Pattern Design Konto?',
  CONFIRM_VECTEEZY_ACCOUNT_KEY: 'Sie haben noch kein Vecteezy-Konto?',
  COUNTRY: 'Land',
  CREATE_ACCOUNT: 'Benutzerkonto anlegen',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Brauch',
  CUSTOM_PRICE_SIGN_IN_KEY:
    'Melden Sie sich für den nächsten Schritt an, um die benutzerspezifische Preisgestaltung anzuzeigen.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Neu erstellen',
  DESIGN_KEY: 'Entwerfen',
  DELETE_KEY: 'Löschen',
  DOCUMENT_COLORS: 'Dokumentfarben',
  DONE: 'Fertig!',
  DONE_KEY: 'Fertig',
  DONT_SHOW_ALERT_KEY: 'Nicht mehr anzeigen',
  DOWNLOAD_COLUMN_HEADER_KEY: 'Herunterladen',
  DOWNLOAD_APP_TITLE_KEY: 'Sie können die App hier herunterladen:',
  DOWNLOAD_LINK_KEY: 'HP Click hier kostenlos herunterladen',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'HP SmartStream herunterladen',
  DOWNLOAD_INSTR_KEY:
    'Stellen Sie sicher, dass Sie HP Click installiert haben, bevor Sie fortfahren',
  DOWNLOAD_SMARTSTREAM_KEY: 'HP SmartStream herunterladen',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox-Import',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'Die Bildgröße muss weniger als 1 GB betragen. Wir akzeptieren die Formate PDF, PNG, JPG, SVG und TIFF.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime-Suche',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime-Bilder',
  DUPLICATE_KEY: 'Duplizieren',
  EACH_ITEM_PRICE_KEY:
    'Ihr Design enthält Inhalte von einem unserer Premium-Anbieter für Inhalte. Die aufgegliederte Preisgestaltung für jedes Element ist unten zusammengefasst.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Design bearbeiten',
  EDIT_LOWERCASE_KEY: 'bearbeiten',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'Es ist ein Fehler aufgetreten. Versuchen Sie es später erneut.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Beim Öffnen der heruntergeladenen PDF-Datei ist ein Fehler aufgetreten.',
  EMAIL_KEY: 'E-Mail',
  EMAIL_ADDRESS_KEY: 'E-Mail-Adresse:',
  EMAIL_CHECKBOX_MESSAGE:
    'Ich weiß, dass diese Person damit einverstanden ist, dass sie E-Mails von HP in meinem Namen oder von diesem Druckdienstleister erhalten wird.',
  EXTRA_INFO_KEY: 'Zusatzinformationen',
  EMAIL_NOTIFICATION:
    'In Kürze wird eine E-Mail gesendet. Dies kann ca. 15 Minuten dauern.',
  EMAIL_DIALOG_MESSAGE:
    'Geben Sie die E-Mail-Adresse der Person ein, mit der Sie Ihr Design teilen möchten.',
  ENTER_KEY: 'Eingeben',
  EXISTING_FOLDER_KEY: 'Vorhandener Ordner',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Vor dem Auschecken sicherstellen, dass alle ausgewählten Elemente korrekt sind',
  FINAL_CHECK_TITLE_KEY: 'Abschließende Überprüfung',
  FINISH_KEY: 'Beenden',
  FINISH_LATER_KEY: 'Später beenden',
  FIRSTNAME: 'Vorname',
  FISCAL_NUM: 'Steuernummer',
  FLIP_KEY: 'Spiegeln',
  FOR_KEY: 'zum',
  FORGOT_PASSWORD_KEY: 'Kennwort vergessen?',
  FOTOLIA_KEYWORDS_KEY: 'Schlüsselwörter:',
  FOLDER_NAME: 'Ordnername',
  FOLDER_NAME_KEY: 'Ordnername:',
  FOLDER_ALREADY_EXIST_KEY: 'Dieser Ordnername ist bereits vorhanden',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    'Sie haben gerade Ihr erstes kostenloses Posterdesign abgeschlossen',
  FREE_VECTOR_GRAPHICS_KEY: 'kostenlose Vektorgrafiken',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'OK, verstanden',
  GROUP_ALL_KEY: 'Alle gruppieren',
  GROUP_SCALE: 'Gruppenskalierung',
  GIFT_WRAPS_KEY: 'Geschenkverpackungen',
  GIVE_PROJECT_NAME_KEY: 'Namen für Ihr Projekt eingeben',
  HEIGHT_KEY: 'Höhe',
  TOUR_DESCRIPTION_TEXT:
    'Wir führen Sie jetzt durch den Designerstellungsprozess. Sie können die geführte Tour jederzeit durch Klicken auf das Hilfe-Symbol erneut öffnen.',
  HELP_KEY: 'Hilfe',
  HELPER_TITLE_KEY_1:
    'Erstellen Sie Posterentwürfe aus einer leeren Seite oder aus Millionen von Bildern und Text. Laden Sie Ihre eigenen Inhalte von lokalen Laufwerken, Dropbox oder Social Media hoch',
  HELPER_TITLE_KEY_3: 'Sehen Sie alle Ihre Designarbeiten an einem Ort',
  HELPER_TITLE_KEY_4:
    'Klicken Sie auf Weiter, um das endgültige Design in der Vorschau anzuzeigen und zu beenden',
  HERE_KEY: 'von hier',
  HELP_IMPROVE_KEY:
    'Unterstützen Sie die Verbesserung Ihrer Produktivität und Operatoreffizienz durch die Erweiterung um die Farbproduktion.',
  HIGH_QUALITY_KEY: 'Hochwertig',
  IMAGES_TITLE_KEY: 'Bilder',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Importieren',
  INCHES_COLUMN_HEADER_KEY: 'Zoll',
  INCHES_KEY: ' Zoll',
  INCHES_UNIT_STRING_KEY: 'Zoll',
  INVALID_EMAIL_ADDRESS_KEY: 'Ungültige E-Mail-Adresse',
  INVALID_INFO_KEY: 'Geben Sie Details ein.',
  INVALID_NAME_KEY: 'Ungültiger Name',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Die von Ihnen ausgewählte Datei ist zu groß. Die maximale Dateigröße beträgt 500 MB.',
  INSUFFICIENT_CREDITS_KEY: 'Credits reichen nicht aus',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Das ist kein gültiges Dateiformat. Nur die Formate PDF, JPG, PNG, SVG und TIF können verarbeitet werden.',
  LANDSCAPE_KEY: 'Querformat',
  LANGUAGE_LABLE_KEY: 'Sprache',
  LASTNAME: 'Nachname',
  LEARN_MORE: 'Weitere Infos',
  LEARN_THE_BASICS_KEY: 'Basiswissen aneignen',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Durch Verwendung dieser Anwendung akzeptieren Sie die Bindung an diese',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Diese Website erfüllt die Richtlinien der',
  LEGAL_FOOTER_MESSAGE3_KEY: 'und des',
  LENGTH_STRING_IN_INCHES_KEY: 'Zoll',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'ändern',
  LINK_READER_APP_KEY: 'LinkReader-App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Um hinzugefügte Inhalte zu visualisieren, laden Sie die App LinkReader herunter.',
  LOADING_KEY: 'Wird geladen...',
  LOADING_TEMPLATE_KEY: 'Vorlage wird geladen',
  LOGIN_NOW: 'Jetzt einloggen',
  LOCK_KEY: 'Sperren',
  LOGIN_KEY: 'Anmelden',
  LOGIN_PATTERN_DESIGN_KEY: 'Bei Pattern Design anmelden',
  LOGIN_SUBTITLE_KEY:
    'Anmelden, um benutzerdefinierte Preis- und Zahlungsdetails anzuzeigen',
  LOGIN_VECTEEZY_KEY: 'Bei Vecteezy anmelden',
  LOGIN_DREAMSTIME_KEY: 'Melden Sie sich bei Dreamstime an ',
  LOGOUT_KEY: 'Abmelden',
  MATERIAL_TITLE_KEY: 'MATERIAL',
  MATERIAL_STRING_KEY: 'Material',
  MEASUREMENT_KEY: 'Abmessung',
  METRIC_KEY: 'Metrisch',
  MOBILE: 'Mobiltelefon',
  MODEL_TITLE_KEY: 'Modell',
  MORE_INFO_TEXT_KEY: 'Weitere Informationen',
  MY_GIFTWRAPS_KEY: 'Meine Geschenkverpackungen',
  MY_WORK_KEY: 'Meine Arbeit',
  MY_WORK_SAVE_KEY: 'Ihr Design wurde in Ihrem Arbeitsplatz gespeichert',
  NAME_KEY: 'Name:',
  NEXT_BUTTON_TITLE_KEY: 'Weiter',
  NEW_FOLDER_KEY: 'Neuer Ordner',
  NO_SHADOW_KEY: 'Kein Schatten',
  OBJECT_QUANTITY_KEY: 'Menge',
  OBJECTS_UPPER_CASE_KEY: 'OBJEKTE',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Muster bestellen',
  ORDER_SAMPLE: 'Muster bestellen',
  ORDER_SAMPLE_INFOLABEL_1:
    'Den Teil des Bilds auswählen, den Sie als Muster bestellen möchten',
  ORDER_SAMPLE_INFOLABEL_2:
    'Sie erhalten später eine E-Mail mit einer Detailansicht Ihres Projekts in der tatsächlichen Größe',
  ORDER_SAMPLE_INFOLABEL_3:
    'Dies hilft Ihnen bei der Bewertung von Qualität und Auflösung',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Muster jetzt bestellen',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Sie erhalten eine E-Mail mit einer Nahaufnahme-Ansicht Ihres Projekts mit der tatsächlichen Größe, um die Qualität/Auflösung zu bewerten.',
  ORIENTATION_KEY: 'Ausrichtung',
  OTHER_PRINTING_OPTIONS: 'Andere Druckoptionen',
  PASSWORD_KEY: 'Kennwort',
  PATTERN_COLOR_KEY: 'Musterfarbe',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'Muster zur',
  PDF_GENERATION_ERROR_MESSAGE_KEY:
    'Das Generieren der PDF ist fehlgeschlagen. Versuchen Sie es erneut.',
  PHOTOS_KEY: 'FOTOS',
  PHOTO: 'Foto',
  PHONE: 'Telefon',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Ich besitze die Urheberrechte für dieses Bild und stimme den',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'Die Bildgröße muss weniger als 500 MB betragen. Wir akzeptieren die Formate PNG, JPG, TIFF, SVG und PDF.',
  PIXEL_COLUMN_HEADER_KEY: 'Pixel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Hier Text eingeben...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'id. h. wichtige Dinge, die Sie dem Druckshop mitteilen müssen',
  PLACEHOLDER_INCHES_STRING_KEY: 'Zoll',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'Mein Poster',
  PORTRAIT_KEY: 'Hochformat',
  POSITION: 'Position',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium-Bilder:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Projekt speichern',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Ihr Projekt weist Änderungen auf, die gespeichert werden müssen, bevor Sie fortfahren können.',
  PRICE_COLUMN_HEADER_KEY: 'Preis',
  PRINTER_SERIAL_NUMBER_KEY: 'Druckerseriennummer*',
  PRINTING_ENABLE_DETAILS_KEY:
    'Um den Druck zu aktivieren, benötigen wir nur noch ein paar weitere Details',
  PRINTER_MODELS_KEY: 'Druckermodelle*',
  PROCESSING_KEY: 'Verarbeitung läuft...',
  PROCESSING_ALERT_TXT:
    'Dieses Fenster nicht schließen, während Ihr Design verarbeitet wird',
  PROCESSING_ALERT_TXT2:
    'Nachdem die Verarbeitung abgeschlossen ist, wird HP Click automatisch geöffnet und Ihre Datei heruntergeladen',
  PROCESSING_DONE: 'Sie sind fast fertig!',
  PROCESSING_FILE_TXT: 'Ihre Datei wird verarbeitet.',
  PROCESSING_TIME_TXT:
    'Dies kann einige Zeit dauern, da wir Ihre Erstellung zusammenstellen, um die bestmögliche Bildqualität sicherzustellen',
  PROCESSING_ALERT_TXT3:
    'Ihre PDF wird automatisch auf Ihren Computer heruntergeladen',
  PROCESSING_ALERT_TXT4:
    'Denken Sie daran, dass Sie Ihre JDF-Verbindung zur Automatisierung in den Einstellungen konfigurieren können',
  PREMIUM_CONTENT_KEY: 'Premium-Inhalt',
  PREVIEW_KEY: 'Vorschau',
  PROFESSIONAL_USE_TITLE_KEY: 'professionellen Verwendung.',
  PROJECT_NAME_KEY: 'Projektname',
  PROJECT_NAME: 'Projektname:',
  PROJECT_ALREADY_EXIST_KEY: 'Dieser Projektname ist bereits vorhanden',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Dieser Projektname ist bereits vorhanden',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Dieser Ordnername ist bereits vorhanden',
  PIXELATION_WARNING_KEY: 'Verpixelungswarnung',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Aufgrund der Auflösung Ihres hochgeladenen Fotos kann Ihre Haut verzerrt oder verzerrt sein. Um sicherzustellen, dass keine Unschärfe entsteht, laden Sie bitte ein qualitativ hochwertiges Bild hoch und vermeiden Sie Bilddehnung. Wenn Sie mit der Vorschau zufrieden sind und fortfahren möchten, fahren Sie mit dem Senden fort.',
  REGISTER_CONTACTINFO: 'Kontaktinformation',
  REGISTER_INFO: 'Informationen registrieren',
  REGISTER_PATTERNSUB1: 'Als wertvoller HP-Kunde',
  REQUIRED_FIELDS_KEY: 'Erforderliche Felder',
  REQUIRED_FIELDS_TEXT_KEY: 'Erforderliche Felder',
  REQUIRED_STRING_KEY: 'ERFORDERLICH',
  RECOLOR_KEY: 'Neu einfärben',
  RADICALLY_SIMPLE_KEY: 'Äußerst einfache Drucksoftware',
  RIPSELECTION_HEAD:
    'Da dies Ihre erste Verwendung ist, wählen Sie die bevorzugte kompatible Drucksoftware aus',
  RIPSELECTION_DESC:
    'Ihre Auswahl wird zu Ihrem standardmäßigen Druckoptionenpfad für zukünftige Ausdrucke. Änderungen können später in den Einstellungen vorgenommen werden',
  REGISTER_COMPANYINFO: 'Firmeninformation',
  REGISTER_KEY: 'Registrieren',
  REGISTER_NOW: 'Jetzt registrieren',
  REOLOR_KEY: 'Neu einfärben',
  REQUEST_SAMPLE_KEY: 'Muster anfordern',
  RESIZE_KEY: 'Größe anpassen',
  RESIZE_ARBITRARILY_KEY: 'Größe beliebig anpassen',
  RESIZE_PROPORTIONALLY_KEY: 'Größe proportional anpassen',
  REVIEW_AND_SUBMIT_KEY: 'Überprüfen und absenden',
  REQUEST_FOR_QUOTATION: 'Angebotsanforderung',
  RIGHT_LOGO_TEXT_KEY: 'von',
  ROTATE_KEY: 'Drehen',
  ROTATE_LEFT_KEY: 'Um 90° nach links drehen',
  ROTATE_RIGHT_KEY: 'Um 90° nach rechts drehen',
  ROTATION_KEY: 'Drehung',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Zeilen und Spalten',
  ROYALTY_FREE_KEY: 'gebührenfrei',
  ROYALTY_KEY: 'Abgabe',
  SALUTATION: 'Anrede',
  SAVE_KEY: 'Speichern',
  SAVING_KEY: 'Wird gespeichert...',
  SAVE_INSPIRATION: 'Inspiration speichern',
  SAVE_TEMPLATE: 'Vorlage speichern',
  SAVE_DIALOG_TITLE: 'Projekt speichern',
  SAVE_PROJECT_NAME_KEY: 'Zuerst Ihr Projekt speichern',
  SAVEDIALOG_MESSAGE:
    'Melden Sie sich an, um Ihr Projekt zu speichern.Wenn Sie über kein Konto verfügen, unterstützen wir Sie bei der Erstellung. Ihr Fortschritt geht nicht verloren.',
  SEAMLESS_KEY: 'nahtlos',
  SCALE_INFO_STRING_KEY: 'Bild skalieren, um es an Ihr Design anzupassen',
  SCALE_KEY: 'Skalieren',
  SCALE_ALL_KEY: 'Alle skalieren',
  SCALE_TO_FILL_KEY: 'Komplett einpassen',
  SEARCH_BUTTON_TITLE_KEY: 'Suchen',
  SELECT_CUSTOM_SIZE_KEY: 'Benutzerdefinierte Größe auswählen',
  SELECT_CUSTOM_KEY: 'Brauch',
  SEARCH_TITLE: 'Suchen',
  SELECTED_IMAGE_KEY: 'Ausgewähltes Bild:',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Wählen Sie die Größe der Geschenkverpackung',
  SELECT_COUNTRY: 'Land auswählen',
  SELECT_SALUTATION: '---Wählen---',
  SELECT_POSTER_SIZE_KEY: 'Wählen Sie die Postergröße aus',
  SELECT_PRINTING_OPTION_KEY: 'Bevorzugte Druckoption auswählen',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Installationsanweisungen zusenden',
  SEND_TO_BACK_KEY: 'In den Hintergrund',
  SEND_KEY: 'Senden',
  SEND_TO_PRINT_TITLE_KEY: 'Zum Drucken senden',
  SET_SIZE_KEY: 'Größe festlegen',
  SETTINGS_KEY: 'Einstellungen',
  SETTINGS_UPPERCASE_KEY: 'EINSTELLUNGEN',
  SHARE_KEY: 'Freigeben',
  SIGNED_IN_AS_KEY: 'Angemeldet als',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Anmelden oder registrieren, um die benutzerspezifischen Preis- und Zahlungsdetails anzuzeigen',
  SIGN_UP_NOW_KEY: 'Jetzt registrieren',
  SKIP_KEY: 'Überspringen',
  SOLID_COLORS_KEY: 'Vollfarben',
  SQFT_UNIT_STRING_KEY: 'Quadratfuß',
  SQM_UNIT_STRING_KEY: 'm²',
  START_TOUR_KEY: 'Tour starten',
  STATUS_MSG: 'Ihre Datei wurde zum Drucken gesendet!',
  SUBMIT_BUTTON_KEY: 'einreichen',
  SHARE_LINK_LABEL: 'Typ des Links auswählen, den Sie freigeben möchten',
  SHARE_EDIT_LINK: 'Verknüpfung bearbeiten',
  SHARE_VIEW_LINK: 'Link anzeigen',
  SHARE_YOUR_CREATION: 'Erstellung freigeben!',
  STREET_ADD: 'Adresse',
  TARGET_VIEWING_HINT:
    '* Der Zielbetrachtungsabstand kann über die Einstellungen geändert werden.',
  TERMS1_KEY: 'Bedingungen',
  TERMS2_KEY: 'HP Datenschutzerklärung',
  TERMS3_KEY: 'HP Hinweis zu Rechten an personenbezogenen Daten',
  TERMS_OF_USE_KEY: 'Nutzungsbedingungen',
  TERMS_OF_USE: 'Nutzungsbedingungen.',
  TEXT_SHADOW_COLOR_KEY: 'Textschattenfarbe',
  TEXT_ANCHOR_MIDDLE: 'Mitte',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Kachel',
  TOTAL_KEY: 'GESAMT',
  TOTAL_PRICE_KEY: 'Gesamt:',
  TRANSPARENCY_KEY: 'Transparenz',
  TEMPLATES_KEY: 'Vorlagen',
  TEMPLATES_UPPER_CASE_KEY: 'VORLAGEN',
  THANK_YOU_KEY: 'Herzlichen Dank',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Sperre aufheben',
  UNGROUP_KEY: 'Gruppierung aufheben',
  UPDATE_TEXT_KEY: 'Aktualisieren',
  UPLOAD_KEY: 'Hochladen',
  UPLOAD_LOGO_KEY: 'Logo hochladen',
  UPLOAD_IMAGE_KEY: 'Eigenes Bild hochladen',
  UPLOAD_UPPERCASE_KEY: 'HOCHLADEN',
  USER_NAME: 'Benutzername',
  USER_TYPE_TITLE_KEY: 'Welche Art von Benutzer sind Sie*',
  UNTILE_KEY: 'Kachelung aufheben',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Suche',
  VALIDITY_KEY: 'Gültigkeit',
  VANILLA_LOGIN_DIALOG_KEY:
    'Kostenlos beitreten, um Ihr Design zu speichern und zu drucken und die gespeicherte Arbeit anzuzeigen',
  VANILLA_PREVIEW_MESSAGE_KEY:
    "Dies ist die Vorschau Ihres Designs. Überprüfen Sie, ob das Design fertig ist, bevor Sie fortfahren, oder wählen Sie 'Bearbeiten', um Änderungen vorzunehmen.",
  VAT_KEY: 'MwSt',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'Vektor',
  VIEW_FOTOLIA_KEY: 'In Fotolia© anzeigen',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Designdetails anzeigen',
  VIEW_DESIGNER_PROFILE_KEY: 'Designerprofil anzeigen',
  VIEW_PRICE_KEY: 'Preis anzeigen',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Suche',
  WALL_POSTER_KEY: 'Poster',
  WALL_SIZE_TEXT_KEY: 'Wandgröße',
  WARNING_KEY: 'Warnung',
  WEBSITE: 'Webseite',
  WIDTH_KEY: 'Breite',
  YOU_CAN_ALWAYS_ACCESS: 'Sie können immer auf Ihre Designs zugreifen in ',
  YOUR_NAME_KEY: 'Ihr Name',
  YOUR_SELECTION_WILL_KEY:
    'Ihre Auswahl wird zu Ihrem standardmäßigen Druckpfad für zukünftige Ausdrucke.',
  YOUR_PROJECT_KEY: 'Ihr Projekt:',
  PROJECT_NAME_ERROR_TEXT: 'Geben Sie einen Namen für Ihr Projekt ein.',
  PROJECT_FOLDER_ERROR_TEXT:
    'Geben Sie einen Namen für Ihren Projektordner ein.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Einstellungen Pixelwarnung',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Mindestbetrachtungsabstand',
  MINIMUM_ZOOM_WARNING:
    'Dieser Hintergrund kann nicht weiter herunterskaliert werden, da Sie bereits die Mindesthöhe oder -breite erreicht haben, die zum Abdecken der Wand benötigt wird.',
  BACKGROUND_UPLOAD_KEY: 'Hintergrund',
  OBJECT_UPLOAD_KEY: 'Objekt',
  PHOTO_UPLOAD_KEY: 'Foto',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Keine dreamstime Inhalte gefunden',
  NO_ELEMENT_ERROR_MESSAGE: 'Kein Element gefunden.',
  NO_MORE_IMAGES_FOUND_KEY: 'Keine weiteren Bilder gefunden',
  NO_PATTERN_ERROR_MESSAGE: 'Keine Muster gefunden.',
  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  ALREDY_HAVE_AN_ACCOUNT: 'Habe schon eine {0} Konto?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Zu {0} ändern',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex farbe: {0}',
  NEAR_KEY: 'Nahe',
  FAR_KEY: 'Weit',
  CLOSE_UP_KEY: 'Nahansicht',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'Die Bilder, die Sie verwenden möchten, sind entweder kleiner oder größer als der von Ihnen verwendete Designbereich.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'Um bessere Ergebnisse zu erzielen, verwenden Sie ein Bild mit 999 Auflösung',
  MESSAGE_KEY: 'Nachricht:',
  VIEWS_KEY: '{0} Ansichten',
  COST_DESCRIPTION_MESSAGE_KEY:
    "Dies ist eine Zusammenfassung der Kosten in Bezug auf die Premium-Inhalte, die in Ihrem Design enthalten sind. {0} Durch Auswählen von 'Fertigstellen' erklären Sie sich damit einverstanden, dass Ihnen die folgenden Kosten durch die Anbieter von Inhalten berechnet werden.",
  DEFAULT_PRINTING_OPTION_KEY: '{0} ist Ihre Standarddruckoption,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' Sie erhalten hochauflösende Bilder im Wert von 100 US-Dollar {0} um mit all Ihren kreativen Bedürfnissen zu helfen!',
  REGISTER_PATTERNSUB3:
    'Melden Sie sich heute und in den nächsten 30 Tagen an. Laden Sie die Creative-Dateien von unserer Inhaltsbasis mit 25 Millionen Fotos herunter {0} kann Ihnen helfen, Ihre kreativen Bedürfnisse zu erfüllen.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Sie haben so stark skaliert, dass das gedruckte Bild möglicherweise verpixelt erscheint, wenn Sie es sich in einem Abstand von {0} {1} * ansehen (die aktuelle Druckauflösung beträgt {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'Der empfohlene Sichtabstand würde {0} {1} betragen. Wenn dieser Abstand nicht geeignet ist, verringern Sie die Skalierung dieses Bildes oder die Größe der Wand.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Die empfohlene Mindestbildgröße sollte {0} x {1} Pixel betragen.',
  MATERIAL_CHOICE_APPLIED: 'Materialwahl angewendet.',
  UPLOAD_STATUS: '{0}% von {1}MB',
  REGISTER_TO: 'Registrieren Sie sich bei {0}',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MINIMUM_DIMENSIONS_KEY: 'Mindestmaße sind {0} (B) x {1} (H).',
  MINIMUM_HEIGHT_KEY: 'Mindesthöhe beträgt {0}.',
  MINIMUM_WIDTH_KEY: 'Mindestbreite beträgt {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximalabmessungen sind {0} (B) x {1} (H).',
  MAXIMUM_WIDTH_KEY: 'Maximale Breite beträgt {0}.',
  MAXIMUM_HEIGHT_KEY: 'Maximale Höhe beträgt {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Geben Sie numerische Abmessungen größer als Null ein.',
  PROCESSING_FAILED:
    'Verarbeitung fehlgeschlagen. Versuchen Sie es später erneut',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'Mehrseitige PDFs werden nicht unterstützt.',
  OF_KEY: 'von',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'Leider werden verschlüsselte PDFs nicht unterstützt.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Datei {0} von {1} wird importiert',
  RECOLORING_KEY: 'Wird neu eingefärbt...',
  TEXT_COLOR_KEY: 'Textfarbe',
  SOLID_COLOR_KEY: 'Vollfarbig',
  AUTHENTICATE_DIALOG_TITLE: 'Diese Inhaltsquelle ist kennwortgeschützt',
  AUTHENTICATE_FAILED_MESSAGE: 'Authentifizierung fehlgeschlagen!',
  DROPBOX_IMPORT_ERROR_HEADER:
    'Beim Import einiger Dateien ist ein Problem aufgetreten',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Seitengröße Warnung!',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Diese Inspirationsvorlage hat eine Standardgröße von {0} X {1} {2}. Ihre Seitengröße wird automatisch an diese Vorlage angepasst.',
  MODIFY_SIZE_WARNING:
    'Wenn Sie die Größe dieses Designs ändern möchten, können Sie dies auf der Registerkarte „Einstellungen“ tun. Designelemente müssen möglicherweise bearbeitet werden, um sie an die gewünschten Abmessungen anzupassen.',
  RANDOMIZE_KEY: 'Zufällig wählen',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Projekt',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Wählen Sie Ihren Laptop aus',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'Vorname',
  LAST_NAME_KEY: 'Nachname',
  PHONE_NUMBER_KEY: 'Telefon-Nr.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Ungültige Telefonnummer',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'Ich stimme den Nutzungsbedingungen zu',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'Ich bin einverstanden, dass meine personenbezogenen Informationen an HP weitergegeben werden, damit ich über zukünftige HP Kampagnen informiert werden kann.*',
  SERVICE_PROVIDER_CONDITION:
    'Ich bin einverstanden, dass meine Daten für den Druck- und Auslieferungsprozess an Dienstleister weitergegeben werden.*',
  ORDER_DESIGN: 'Design bestellen',
  SUBMIT_YOUR_DESIGN: 'Ihr Design absenden',
  SUBMISSION_DESIGN_ORDER: 'Einsendung für Designbestellung',
  ENTER_REQUIRED_FIELDS_KEY: 'Füllen Sie die Pflichtfelder aus',
  ADDRESS_KEY: 'Adresse',
  INVALID_ADDRESS_KEY: 'Ungültige Adresse',
  CITY_KEY: 'Stadt',
  INVALID_CITY_KEY: 'Ungültige Stadt',
  COUNTRY_KEY: 'Land',
  STATE_KEY: 'Bundesland',
  ZIP_KEY: 'PLZ',
  INVALID_ZIP_KEY: 'Ungültige Postleitzahl',
  ORDER_NUMBER: 'Bestellnummer',
  YOUR_DETAILS_KEY: 'Deine Details',
  APPLY_DESIGN_COMPETITION: 'Für Designwettbewerb bewerben',
  NOTICE_KEY: 'Beachten:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'Damit ein PC-Skin perfekt an Ihr Design angepasst werden kann, müssen Sie das genaue Modell auswählen, das dem Kauf entspricht (siehe Rechnung).',
  RESTART_PROJECT_ALERT_TITLE: 'Projekt neu starten?',
  DISCARD_ALERT_MESSAGE: 'Ihr aktuelles Projekt wird verworfen',
  RESTART: 'Neu starten',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'Echtheits',
  AUTHENTICITY_STRING: 'zertifikat',
  PLEASE_WAIT: 'Bitte warten',
  PROTECTING_YOUR_DATA: 'Schutz Ihrer Daten ...',
  SEARCH_YOUR_LAPTOP_KEY: 'Suchen Sie Ihren Laptop', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Hoppla! Wir konnten keine Laptops für Ihre Suche finden.', // Google translated
  SERIAL_NUMBER_KEY: 'Seriennummer',
  LOCKED_PROJECT: 'Gesperrtes Projekt',
  LOCKED_MESSAGE:
    'Dieses Projekt wurde bereits bestellt und kann nicht geändert werden. Sie können dieses Projekt nur ansehen.',
  EXPIRED_PROJECT: 'Abgelaufenes Projekt',
  EXPIRED_MESSAGE: 'Dieses Projekt ist abgelaufen.',
  DELETED_PROJECT: 'Gelöschtes Projekt',
  DELETED_MESSAGE: 'Dieses Projekt wurde gelöscht.',
  CHOOSE_GROUP_TYPE: 'Typ {0} auswählen',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Geben Sie Zahlen größer als Null ein.',
  SIZE_KEY: 'Größe',
  DISTANCE_FROM_KEY: 'Abstand von',
  MYROOM_UPPERCASE_KEY: 'MEIN ZIMMER',
  FURNITURE_KEY: 'Möbel',
  FIXTURES_KEY: 'Vorrichtungen',
  ADD_A_WALL_KEY: 'Wand hinzufügen',
  SELECT_A_WALL_KEY: 'Wand auswählen',
  LEFT_KEY: 'Links',
  RIGHT_KEY: 'Rechts',
  DELETE_WALL_KEY: 'Wand löschen',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Wählen Sie den Leinwandtyp',
  MAXIMUM_WALL_SIZE_KEY: 'Maximale Wandgröße beträgt {0} Quadrat{1}',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: 'Leinwandhöhe übersteigt Wandhöhe.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: 'Leinwandbreite übersteigt Wandbreite.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Maximale Anzahl an Spalten für die aktuelle Breite lautet {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Maximale Anzahl an Zeilen für aktuelle Höhe lautet {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'Die Wandbreite ist kleiner als die Leinwandbreite.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'Die Wand muss eine Mindestbreite von {0} aufweisen. ',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'Die Wand muss eine Mindesthöhe von {0} aufweisen.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Die Wandhöhe ist kleiner als die Leinwandhöhe.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Maximale Wandhöhe beträgt {0} {1}.',
  FINISHING_KEY: 'Weiterverarbeitung',
  MIRROR_KEY: 'Spiegeln',
  NATURAL_KEY: 'Natürlich',
  ROWS_KEY: 'Zeilen',
  COLUMNS_KEY: 'Spalten',
  DEFAULT_WALL_SIZE_KEY: 'Standardwandgröße',
  EDIT_KEY: 'Bearbeiten',
  TOP_KEY: 'Oben',
  BOTTOM_KEY: 'Unten'
};
